import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { User } from '../../user/user';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-useripadress-update',
  templateUrl: './useripadress-update.component.html'
})
export class UseripadressUpdateComponent extends BaseUpdateComponent<User> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService)
  }

}
